import { includes, omit } from 'lodash'

import { extractBoldText, stripHtmlFromText } from '../../common/utils'

import { UNKNOWN_WORD_TYPE } from '../constants'

export const transformUnknownWordFormValuesToUpdateArgs = formValues => {
  const convertedContextWithHighlight = formValues.context
  const selectedValueWithHtml = extractBoldText(convertedContextWithHighlight)
  const selectedValue = stripHtmlFromText(selectedValueWithHtml?.[0])

  let { isContextDependant } = formValues

  if (!isContextDependant) {
    isContextDependant = includes(
      [
        UNKNOWN_WORD_TYPE.ALLERGEN_LABEL.value,
        UNKNOWN_WORD_TYPE.DIET_LABEL.value,
      ],
      formValues.type,
    )
  }

  return omit(
    {
      ...formValues,
      isContextDependant,
      selectedValue,
    },
    ['context', 'originField'],
  )
}
